// extracted by mini-css-extract-plugin
export default {"StyledAccordionDetails__root":"Info_StyledAccordionDetails__root__M-WuQ","text":"Info_text__soWxc"};